import React, { useEffect, useState } from 'react'
import AssetCard from '../components/UI/AssetCard'
import { ASSET_TYPES, fetchAssetsByType } from '../api/assetApi'
import '../assets/css/services.css'

const Services = () => {
  const [services, setServices] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    fetchAssetsByType(ASSET_TYPES.SERVICES)
      .then(setServices)
      .catch((err) => setError(err.message || 'Failed to load services'))
      .finally(() => setLoading(false))
  }, [])

  return (
    <>
      <section className='space-top'>
        <div className="container">
          <div className="mb-[36px]">
            <h2 className='text-lora font-semibold'>
              Our Service
            </h2>
                <p className='mb-0'>
                    Explore our range of astrology, numerology, vastu, and occult solutions designed for harmony and growth
                </p>
          </div>
          {loading && <p className="text-center py-5">Loading services...</p>}
          {error && <p className="text-center text-danger py-5">{error}</p>}
          {!loading && !error && services.length === 0 && (
            <p className="text-center py-5">No services available.</p>
          )}
          <div className="row g-4">
            {services.map((service) => (
              <div className="col-lg-4 col-md-6 col-12 d-flex" key={service.id}>
                <AssetCard
                  asset={service}
                  actionLabel="Book Consultation"
                  actionTo="/consult"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Services
